document.addEventListener('DOMContentLoaded', () => {
  const tabButtons = document.querySelectorAll('.tab-button');
  const tabContents = document.querySelectorAll('.tab-content');
  const tabsContainer = document.querySelector('.tabs');

  // Create and append the tab indicator
  const tabIndicator = document.createElement('div');
  tabIndicator.className = 'tab-indicator';
  tabsContainer.appendChild(tabIndicator);

  // Function to activate tab and move indicator
  function activateTab(tabName) {
    // Deactivate all tabs
    tabButtons.forEach((button) => button.classList.remove('active'));
    tabContents.forEach((content) => content.classList.remove('active'));

    // Activate selected tab
    const selectedButton = document.querySelector(`[data-tab="${tabName}"]`);
    const selectedContent = document.getElementById(tabName);

    selectedButton.classList.add('active');
    selectedContent.classList.add('active');

    // Move the indicator
    tabIndicator.style.width = `${selectedButton.offsetWidth}px`;
    tabIndicator.style.left = `${selectedButton.offsetLeft}px`;
  }

  // Add click handlers to tabs
  tabButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const tabName = button.getAttribute('data-tab');
      activateTab(tabName);
    });
  });

  // Function to update tab widths and indicator position
  function updateTabWidths() {
    const visibleTabs = document.querySelectorAll(
      '.tab-button:not([style*="display: none"])'
    );
    const width = `${100 / visibleTabs.length}%`;
    visibleTabs.forEach((tab) => (tab.style.width = width));

    // Update indicator for the active tab
    let activeTab = document.querySelector('.tab-button.active');

    if (!activeTab) {
      activeTab = visibleTabs[0];
      activeTab.classList.add('active');
    }

    if (activeTab) {
      tabIndicator.style.width = `${activeTab.offsetWidth}px`;
      tabIndicator.style.left = `${activeTab.offsetLeft}px`;
    }
  }

  const activeTabContent = document.querySelector('.tab-content.active');

  if (!activeTabContent && tabContents.length > 0) {
    tabContents[0].classList.add('active');
  }

  // Call initially and whenever tabs are shown/hidden
  updateTabWidths();
});
